// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1M80F","policies":"_2Wk8j","contactless":"_2nPjV","contactlessLabel":"_1Wp86"};